import type { FeatureFlags } from "@/config/features";
import type { TimelineSpan } from "@/data/join-chapters";
import type { JourneyMode } from "@/data/schema/compiled";
import type { TimelineUiPreferences } from "@/lib/timeline/view/TimelineUiPreferences/prefs";
import { TimelineOptionsMenu } from "./TimelineOptionsMenu";
import { TimelinePlayerSheet } from "./TimelinePlayerSheet";

interface TimelinePlayerOptionsAreaProps {
  isPhone: boolean;
  sheetOpen: boolean;
  closeSheet: () => void;
  setSheetHost: (host: HTMLElement | null) => void;
  uiPrefs: TimelineUiPreferences;
  updateUiPrefs: (patch: Partial<TimelineUiPreferences>) => void;
  featureFlags: FeatureFlags;
  spans: TimelineSpan[];
  spanId: string;
  onSpanIdChange: (id: string) => void;
  journey: JourneyMode;
  onJourneyChange: (journey: JourneyMode) => void;
  onJourneyPrefetch: () => void;
  getShareLink: () => string;
}

/** A sheet from the playback bar on a phone, and the menu in the corner elsewhere. */
export function TimelinePlayerOptionsArea({
  isPhone,
  sheetOpen,
  closeSheet,
  setSheetHost,
  uiPrefs,
  updateUiPrefs,
  featureFlags,
  spans,
  spanId,
  onSpanIdChange,
  journey,
  onJourneyChange,
  onJourneyPrefetch,
  getShareLink,
}: TimelinePlayerOptionsAreaProps) {
  return (
    isPhone ? (
            sheetOpen ? (
              <TimelinePlayerSheet
                onClose={closeSheet}
                onPlaybackHost={setSheetHost}
                journey={journey}
                onJourneyChange={onJourneyChange}
                onJourneyPrefetch={onJourneyPrefetch}
                spans={spans}
                spanId={spanId}
                onSpanIdChange={onSpanIdChange}
                uiPrefs={uiPrefs}
                updateUiPrefs={updateUiPrefs}
                featureFlags={featureFlags}
                getShareLink={getShareLink}
              />
            ) : null
          ) : (
            <TimelineOptionsMenu
              spoilerLevel={uiPrefs.spoilerLevel}
              onSpoilerLevelChange={(spoilerLevel) => {
                updateUiPrefs({ spoilerLevel });
              }}
              transportSizeLevel={uiPrefs.transportSizeLevel}
              onTransportSizeLevelChange={(level) => {
                updateUiPrefs({ transportSizeLevel: level });
              }}
              boardModelDebugMenu={featureFlags.boardModelDebugMenu}
              boardModelDebug={uiPrefs.boardModelDebug}
              onBoardModelDebugChange={(enabled) => {
                updateUiPrefs({ boardModelDebug: enabled });
              }}
              spans={spans}
              spanId={spanId}
              onSpanIdChange={onSpanIdChange}
              universeJourneyView={featureFlags.universeJourneyView}
              journey={journey}
              onJourneyChange={onJourneyChange}
              onJourneyPrefetch={onJourneyPrefetch}
              getShareLink={getShareLink}
              open={uiPrefs.optionsOpen}
              onOpenChange={(open) => {
                updateUiPrefs({ optionsOpen: open });
              }}
            />
          )
  );
}
